export default function userAvatarReducer(
   state = { photo: null },
   { type, payload }
) {
   switch (type) {
      case 'SET_USER_AVATAR_PHOTO':
         return {
            photo: payload.photo
         }
      default:
         return state
   }
}
